import clsx from "clsx";
import { Fragment, ReactNode } from "react";
interface FilterRowProps {
  title: string | ReactNode;
  children: ReactNode;
  className?: string;
  rowClassName?: string;
}

export default function FilterRow({
  title,
  children,
  className,
  rowClassName,
}: FilterRowProps) {
  return (
    <Fragment>
      <span
        className={clsx(
          "grid-cols-1 h-[1.375rem] flex items-center w-fit",
          className
        )}
      >
        {title}
        {title && ":"}
      </span>
      <div className={clsx("grid-cols-1 h-[1.375rem]", rowClassName)}>
        {children}
      </div>
    </Fragment>
  );
}
